import { ApprovalOddsTranslations } from '../../components/ApprovalOddsBadge';
import {
  staticText,
  brandSpecificStaticText,
} from '../../utils/translations/staticText';

// Keys consumed by getCardTitle (reused from ComparisonTable). Kept in sync
// with src/cms-blocks/ComparisonTable/i18n/index.ts.
const cardTitleKeys = {
  card: {
    _: 'Card',
    zh: '信用卡',
  },
  loan: {
    _: 'Loan',
    zh: '銀行/財務公司',
  },
  product_bka: {
    _: 'Product Name',
    zh: '銀行戶口',
  },
  product_stk: {
    _: 'Product Name',
    zh: '投資戶口',
  },
  product_ci: {
    _: 'Product Name',
    zh: '保險公司',
  },
  product_ti: {
    _: 'Product Name',
    zh: '保險公司',
  },
};

// Personal Loan mode (CMS-1928). The same keys in both brands; only the
// exclusive source is named after the brand, so each brand sets it itself.
const personalLoanKeys = {
  // `{amount}` arrives currency-prefixed and separated; `{tenure}` is a month count.
  loan_basis: {
    _: 'Based on a {amount} loan over {tenure} months.',
    zh: '以 {amount} 貸款額，{tenure} 個月還款期計算。',
  },
  total_reward: {
    _: 'Total Reward',
    zh: '總獎賞價值',
  },
  reward_source_provider: {
    _: 'Provider',
    zh: '金融機構優惠',
  },
  // The static label of the rate stacked under ANNUAL_RATE (CMS-1928 R3), SingSaver only.
  eir: {
    _: 'EIR',
  },
};

const moneyhero = staticText({
  ...cardTitleKeys,
  ...ApprovalOddsTranslations,
  title: {
    _: '⚡ Quick Answer',
    zh: '⚡ 快速解答',
  },
  default_anchor_label: {
    _: 'See Full Comparison Below',
    zh: '查看完整比較',
  },
  na: {
    _: '-',
    zh: '-',
  },
  more_label: {
    _: 'More:',
    zh: '更多：',
  },

  brand_reward: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獨家獎賞',
  },
  brand_reward_stk_bka: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  trending_reward_pick: {
    _: 'Trending Reward',
    zh: '熱門獎賞精選',
  },
  hot_reward_pick: {
    _: 'Hot Reward Pick',
    zh: '熱門獎賞精選',
  },
  ...personalLoanKeys,
  reward_source_exclusive: {
    _: 'MoneyHero',
    zh: 'MoneyHero獨家',
  },
});

const singsaver = staticText({
  ...cardTitleKeys,
  ...ApprovalOddsTranslations,
  title: {
    _: '⚡ Quick Answer',
  },
  default_anchor_label: {
    _: 'See Full Comparison Below',
  },
  na: {
    _: '-',
  },
  more_label: {
    _: 'More:',
  },

  brand_reward: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  brand_reward_stk_bka: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  trending_reward_pick: {
    _: 'Trending Reward',
  },
  hot_reward_pick: {
    _: 'Hot Reward Pick',
  },
  ...personalLoanKeys,
  reward_source_exclusive: {
    _: 'SingSaver',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: moneyhero,
  singsaver,
});
